/* global IntersectionObserver */
'use strict';
// Used to keep track of observers at different margins so we don't create a ton
let intersectionObserverObjects = {};
// The default distance from the viewport at which we start to load elements
const DEFAULT_DISTANCE_TO_VIEWPORT = 800;
function createIntersectionObserver(loadDistance) {
    return new IntersectionObserver(
        (entries, observer) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    observer.unobserve(entry.target);
                    entry.target.onObserved();
                }
            });
        },
        {
            rootMargin: loadDistance + 'px 0px',
        }
    );
}

module.exports = {
    observe: function (el, loadDistance = DEFAULT_DISTANCE_TO_VIEWPORT) {
        // if none exists at that size, create it
        if (!intersectionObserverObjects[loadDistance]) {
            intersectionObserverObjects[loadDistance] = createIntersectionObserver(loadDistance);
        }
        intersectionObserverObjects[loadDistance].observe(el);
    },
    unobserve: function (el, loadDistance = DEFAULT_DISTANCE_TO_VIEWPORT) {
        intersectionObserverObjects[loadDistance].unobserve(el);
    },
};
